import { Select, SelectOptionType, TextAreaInput } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { Col } from 'reactstrap';
import { AzureFilesUploaderControlled } from '../../../../../components/AzureFilesUploader/AzureFileUploaderControlled';
import { FileRequiredTypes } from '../../../../../components/AzureFilesUploader/types';
import { useValidations } from '../../../../../hooks/useValidations';
import { typesObservations } from '../constanst/types-observations';
import { useTexts } from '../hooks/useTexts';
import { StudentObservationFormLoaderData } from '../Loaders/StudentObservationFormLoader';

export interface FormData {
  type: SelectOptionType | null;
  course?: SelectOptionType | null;
  observation: string;
  file: {
    id: number;
    name: string;
  } | null;
}

export function StudentObservationForm({
  disabled = false,
}: {
  disabled?: boolean;
}) {
  const data = StudentObservationFormLoaderData();

  const { modal } = useTexts();
  const texts = modal.inputs;
  const forms = useFormContext<FormData>();
  const { control, watch } = forms;
  const { msgValidations } = useValidations();

  const type = watch('type');
  const file = watch('file');
  const isCourseType = type?.value === typesObservations[1].id;

  return (
    <>
      <Col xs={12} md={isCourseType ? 6 : 12} className="mt-4">
        <Select
          name="type"
          options={data.types}
          label={texts.type.label}
          placeholder={texts.type.placeholder}
          rules={{ required: msgValidations.required }}
          isClearable={false}
          disabled={disabled}
          control={control}
        />
      </Col>
      {isCourseType && (
        <Col xs={6} className="mt-4">
          <Select
            name="course"
            options={data.courses}
            label={texts.course.label}
            placeholder={texts.course.placeholder}
            rules={{ required: msgValidations.required }}
            isClearable={false}
            disabled={disabled}
            control={control}
            shouldUnregister
          />
        </Col>
      )}
      <Col xs={12} className="mt-4">
        <TextAreaInput
          name="observation"
          label={texts.observation.label}
          placeholder={texts.observation.placeholder}
          control={control}
          disabled={disabled}
        />
      </Col>
      <Col xs={12} className="mt-4">
        {disabled ? (
          <>
            {file?.name && (
              <AzureFilesUploaderControlled
                name="file"
                control={control}
                fileType={FileRequiredTypes.SupplementaryObservationDocument}
                label={texts.file.label}
                disabled={disabled}
              />
            )}
          </>
        ) : (
          <AzureFilesUploaderControlled
            name="file"
            control={control}
            fileType={FileRequiredTypes.SupplementaryObservationDocument}
            label={texts.file.label}
            disabled={disabled}
          />
        )}
      </Col>
    </>
  );
}
